import { Box, Typography } from '@mui/material';
import Link from 'components/Link';
import { BigButton } from 'components/v2/common/Buttons/BigButton';
import { Heading1 } from 'components/v2/common/Heading1';
import boxGroup1 from 'assets/images/boxGroup1.svg';

export const Hiring = () => {
  return (
    <Box bgcolor="#DAEFF1" position="relative">
      <Box position="relative" zIndex={1}>
        <Box display="flex" justifyContent="center" mt="44px">
          <Box width="500px" maxWidth="80%">
            <Heading1 xsFontSize={20}>We are Hiring</Heading1>
          </Box>
        </Box>
        <Typography
          align="center"
          mt="41px"
          maxWidth="800px"
          mx="auto"
          // fontSize={24}
          sx={{
            fontSize: {
              xs: 14,
              md: 24,
            },
            lineHeight: {
              xs: '20px',
              md: '37.5px',
            },
          }}
          lineHeight="37.5px"
          color="rgba(0, 0, 0, 0.6)"
        >
          Reshape fundraising in India with us.
          <br /> We are always eager to hire fresh talent.
          <br />
          Email the HR Team at
          <br />
          <Link
            noLinkStyle
            href="mailto:talent@podworld.in"
            sx={{
              color: '#FF6446',
            }}
          >
            talent@podworld.in
          </Link>{' '}
          for details.
        </Typography>

        <Link
          noLinkStyle
          href="mailto:talent@podworld.in"
          sx={{
            color: '#FF6446',
          }}
        >
          <BigButton
            sx={{
              mx: 'auto',
              mt: 6,
              mb: '68px',
              display: 'block',
            }}
          >
            I am Interested
          </BigButton>
        </Link>
      </Box>
      <Box position="absolute" bottom="5%" left="5%" zIndex={0}>
        <img src={boxGroup1.src} alt="design element" />
      </Box>
    </Box>
  );
};
